import NaverMap, { NaverMapMarkerItem } from './BaseMap';

export interface ReservationRouteSlot {
  id: number;
  shopId: number;
  vendorName: string;
  roomName: string;
  address?: string | null;
  lat?: number;
  lng?: number;
  lon?: number;
  time: string;
  endTime: string;
}

interface RouteNaverMapProps {
  clientId: string;
  slots: ReservationRouteSlot[];
  activeIndex: number | null;
  onSlotSelect: (index: number) => void;
  zoomLevel: number;
  onZoomLevelChange: (zoom: number) => void;
  className?: string;
  style?: React.CSSProperties;
  connectLine?: boolean;
}

export default function RouteNaverMap({
  clientId,
  slots,
  activeIndex,
  onSlotSelect,
  zoomLevel,
  onZoomLevelChange,
  className,
  style,
  connectLine = false

}: RouteNaverMapProps) {
  const slotsWithCoords = slots.filter(
    (slot) =>
      typeof slot.lat === 'number' &&
      typeof (slot.lng ?? slot.lon) === 'number'
  );

  const markers: NaverMapMarkerItem[] = slotsWithCoords.map((slot, index) => ({
    id: slot.id,
    name: `${index + 1}. ${slot.vendorName}`,
    lat: Number(slot.lat),
    lng: Number(slot.lng ?? slot.lon),
    order: index + 1,
    html: `
      <div style="padding:10px 12px; min-width:150px;">
        <div style="font-size:13px; font-weight:700; margin-bottom:4px;">
          ${index + 1}. ${slot.vendorName}
        </div>
        <div style="font-size:12px; color:#6B7280;">
          ${slot.time} ~ ${slot.endTime}
        </div>
        <div style="font-size:12px; color:#6B7280; margin-top:2px;">
          ${slot.roomName}
        </div>
      </div>
    `,
  }));

  const selectedMarkerId =
    activeIndex !== null && slotsWithCoords[activeIndex]
      ? slotsWithCoords[activeIndex].id
      : null;
  
  return (
    <div className={className} style={style}>
      <NaverMap
        clientId={clientId}
        markers={markers}
        selectedMarkerId={selectedMarkerId}
        autoFit={markers.length >= 2}
        zoom={zoomLevel}
        connectLine={connectLine}
        onMarkerClick={(_, index) => onSlotSelect(index)}
        onZoomChanged={onZoomLevelChange}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
}